export default __webpack_public_path__ + "static/borrower_mobile-2f9105518d8804378f2d2c71764fcd48.svg";